function gformAppendUploadButton() {
	$(".ginput_container_fileupload").each(function() {
		var $fileInput = $(this).find('input[type="file"]');
		var $uploadTypeClass = $fileInput.parents('.gfield');
		var label = 'Upload Image';
		if ($uploadTypeClass.is('.gf_filetype_file')) {
			label = 'Upload File';
		}
		$('<div class="button button-white" id="'+$fileInput.attr("id")+'_button"><i class="button-text">'+label+'</i> <span class="icon-upload"></span></div>').appendTo($(this));
	});
}

(function ($) {
	// assume there's only one form per page, and all multi-page form must start
	// from page 1
	var $backButton = $(".panel-form-section .back-button");
	$(document).on('gform_page_loaded', function(event, form_id, current_page) {
		// don't do this on newsletter form
		if (form_id != 1) {
			if (current_page == 1) {
				$backButton.hide();
			} else {
				$backButton.show();
			}
			gformAppendUploadButton();

			$('html,body').animate({scrollTop: 0}, 'slow');	
		}
	});
	$backButton.on("click", function(e) {
		e.preventDefault();
		$(this).parents('.panel-form-section').find('.gform_previous_button').trigger("click");
	});
	$backButton.hide();

	gformAppendUploadButton();

	// special handling for image upload field (grooming form)
	$(document).on("change", "#input_3_7", function() {
		var input = this;
		$("#input_3_7_preview").remove();
		if (input.files && input.files[0]) {
			var isImage = $.inArray(input.files[0].type, ['image/png','image/jpg','image/jpeg']) != -1;
			if (isImage) {
				var $previewContainer = $('<div id="input_3_7_preview" class="gf-image-upload-preview"><div class="remove-button" title="Remove image"></div><img/></div>').appendTo($("#field_3_7"));
				var reader = new FileReader();
				reader.onload = function (e) {
					$previewContainer.find('img').attr('src', e.target.result);
				}
				reader.readAsDataURL(input.files[0]);	
				$("#input_3_7_button .button-text").text("Change image");
				$previewContainer.find('.remove-button').on("click", function() {
					input.value = null;
					$previewContainer.remove();
					$("#input_3_7_button .button-text").text("Upload image");
				});
			} else {
				$('<div id="input_3_7_preview">Please select image file (.png, jpg, jpeg extension).</div>').appendTo($("#field_3_7"));
				$("#input_3_7_button .button-text").text("Upload image");
			}
		}
	});

	// special handling for career application upload fields
	$(document).on("change", "#input_5_6, #input_5_7", function() {
		var input = this;
		var $fileButton = $(this).parents('.ginput_container_fileupload').find('.button .button-text');
		if (input.files && input.files[0]) {
			var filepath = input.files[0].name;
			var fileName = filepath.substring(0, filepath.lastIndexOf(".") + 1);
			var fileExt = filepath.substring(filepath.lastIndexOf(".") + 1, filepath.length);
			if (fileName.length > 15) {
				$fileButton.text(fileName.substring(0, 15) + '..' + fileExt);
			} else {
				$fileButton.text(filepath);
			}
		} else {
			$fileButton.text('Upload File');
		}
	});

	// force readonly to corresponding GF fields 
	$(".gf_readonly input, .gf_readonly select")
		.attr('readonly','readonly');


})(jQuery);
